import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_QUOTE_CONFIG_COVERAGE, APP_FILE_QUOTE_CONFIG_LIST, APP_FILE_QUOTE_CONFIG_REMARKS } from "./Quote.constants";

const QuoteConfigList = Loadable(
  lazy(() =>
    import("./QuoteSettingsRoot").then(
      ({ QuoteSettingsRoot }) => ({
        default: QuoteSettingsRoot,
      })
    )
  )
);
const QuoteConfigCoverage = Loadable(
  lazy(() =>
    import(
      "./QuoteDefaultCoverage/QuoteDefaultCoverage"
    ).then(({ QuoteDefaultCoverage }) => ({
      default: QuoteDefaultCoverage,
    }))
  )
);
const QuoteConfigRemarks = Loadable(
  lazy(() =>
    import(
      "./QuoteDefaultRemarks/QuoteDefaultRemarks"
    ).then(({ QuoteDefaultRemarks }) => ({
      default: QuoteDefaultRemarks,
    }))
  )
);

export const QuoteRoutes = [
   {
        path: `${APP_FILE_QUOTE_CONFIG_LIST}`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <QuoteConfigList />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_QUOTE_CONFIG_COVERAGE}`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <QuoteConfigCoverage />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_QUOTE_CONFIG_COVERAGE}/:defaultCoverageCode`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <QuoteConfigCoverage />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_QUOTE_CONFIG_REMARKS}`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <QuoteConfigRemarks />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_QUOTE_CONFIG_REMARKS}/:defaultRemarksCode`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <QuoteConfigRemarks />
          </AuthorizedRoute>
        ),
      },
];
